var _circle, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentSke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 56,
    viewBox: "0 0 230 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.7183,
    r: 16,
    fill: "#F1F1F4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 0.718262,
    width: 190,
    height: 32,
    rx: 8,
    fill: "#F1F1F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36.7183,
    width: 60.6667,
    height: 10,
    rx: 4,
    fill: "#F1F1F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 104.667,
    y: 36.7183,
    width: 60.6667,
    height: 10,
    rx: 4,
    fill: "#F1F1F4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 169.333,
    y: 36.7183,
    width: 60.6667,
    height: 10,
    rx: 4,
    fill: "#F1F1F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentSke);
export default __webpack_public_path__ + "static/media/comment-ske.427641a9b0d2aa3bf633422a2f4f59fe.svg";
export { ForwardRef as ReactComponent };